import { render, staticRenderFns } from "./im.vue?vue&type=template&id=1f2ecea2&scoped=true"
import script from "./im.vue?vue&type=script&lang=js"
export * from "./im.vue?vue&type=script&lang=js"
import style0 from "./im.vue?vue&type=style&index=0&id=1f2ecea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ecea2",
  null
  
)

export default component.exports